import React, { useContext, useState, useEffect, useMemo } from 'react';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import {
  makeStyles,
  tokens,
  Button,
  mergeClasses,
} from '@fluentui/react-components';
import {
  MessageBar,
  MessageBarActions,
  MessageBarTitle,
  MessageBarBody,
} from '@fluentui/react-message-bar';
import { DismissRegular } from '@fluentui/react-icons';
import { useBulkLocationsSearchContext } from './bulk-locations-search-provider';

const useStyles = makeStyles({
  banner: {
    marginBottom: tokens.spacingVerticalMNudge,
  },
  viewButton: {
    minWidth: '55px',
  },
});

const WarningBanner = () => {
  const classes = useStyles();
  const i18n = useContext(I18nContext);
  const {
    unmatchedLocations, currentSearchCounts,
  } = useBulkLocationsSearchContext();
  const [showWarningBanner, setShowWarningBanner] = useState(unmatchedLocations.length > 0);

  useEffect(() => {
    setShowWarningBanner(currentSearchCounts.unmatchedLocations > 0);
  }, [currentSearchCounts]);

  const bannerMessage = useMemo(() => {
    if (currentSearchCounts.searchTerms === 1 && currentSearchCounts.unmatchedLocations === 1) {
      return {
        title: i18n.getString(_TL_('Location not found.')),
        message: i18n.getString(_TL_('We\'re unable to find your location.')),
      };
    }

    return {
      title: i18n.getString(_TL_('Locations not found.')),
      message: i18n.getString(
        _TL_('We\'re unable to find {{unmatched}} out of {{total}} locations.'),
        { unmatched: currentSearchCounts.unmatchedLocations, total: currentSearchCounts.searchTerms }
      ),
    };
  }, [currentSearchCounts, i18n]);

  return showWarningBanner ? (
    <MessageBar className={mergeClasses(classes.banner, 'bulk-locations-warning-banner')} intent="warning">
      <MessageBarBody>
        <MessageBarTitle>{bannerMessage.title}</MessageBarTitle>
        {bannerMessage.message}
      </MessageBarBody>
      <MessageBarActions
        containerAction={
          <Button
            aria-label={i18n.getString(_TL_('Dismiss'))}
            appearance="transparent"
            icon={<DismissRegular />}
            onClick={() => setShowWarningBanner(false)}
          />
            }
      />
    </MessageBar>
  ) : null;
};

export default WarningBanner;
